var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slogan"},[_c('p',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('p',{domProps:{"textContent":_vm._s(_vm.memo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }